import React, { useState, useEffect } from "react";
import Select from "../Select";
import SearchSelect from "../SerachSelect";
import InputText from "../InputText";
import { post } from "../../utils/api";

const HotelEntry = ({ plan, onUpdate, hotelTypeOptions = [], hotelNameOptions = [] }) => {
  const [hotelPlanOptions, setHotelPlanOptions] = useState([]);
  const [filteredHotels, setFilteredHotels] = useState(hotelNameOptions);

  useEffect(() => {
    if (plan.hotelType?.hoteltypeid) {
      const filtered = hotelNameOptions.filter(
        (h) => h.hoteltypeid === plan.hotelType.hoteltypeid
      );
      setFilteredHotels(filtered.length > 0 ? filtered : hotelNameOptions);
    } else {
      setFilteredHotels(hotelNameOptions);
    }
  }, [plan.hotelType, hotelNameOptions]);

  useEffect(() => {
    if (plan.hotelName?.id) {
      fetchHotelPlanOptions(plan.hotelName.id);
    } else {
      setHotelPlanOptions([]);
    }
  }, [plan.hotelName?.id]);

  const fetchHotelPlanOptions = async (hotelId) => {
    try {
      const result = await post("/getOptionList", {
        type: "hotelname_hotelwiseplan",
        stateid: hotelId,
      });
      if (result?.data) {
        setHotelPlanOptions(
          result.data.map((item) => ({
            label: item.label,
            value: item.value || item.label,
            pph: item.pph,
          }))
        );
      }
    } catch (err) {
      console.error("Error fetching hotel plan options:", err);
    }
  };

  return (
    <div className="">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">Hotel Type</label>
          <SearchSelect
            options={hotelTypeOptions}
            value={plan.hotelType || null}
            onChange={(option) => {
              onUpdate("hotelType", option);
              onUpdate("hotelName", null);
              onUpdate("hotelOptions", null);
            }}
            placeholder="Select Type..."
            displayLabel="hoteltype"
          />
        </div>
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">Hotel Name</label>
          <SearchSelect
            options={filteredHotels}
            value={plan.hotelName || null}
            onChange={(option) => {
              onUpdate("hotelName", option);
              onUpdate("hotelOptions", null);
            }}
            placeholder="Select Hotel..."
          />
        </div>
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">Hotel Options</label>
          <Select
            options={hotelPlanOptions}
            value={hotelPlanOptions.find((o) => o.label === plan.hotelOptions?.label) || null}
            onChange={(option) => onUpdate("hotelOptions", option)}
            placeholder="Select Option..."
          />
        </div>
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">No. of Rooms</label>
          <InputText
            placeholder="e.g. 5"
            value={plan.noofRooms || ""}
            onChange={(e) => onUpdate("noofRooms", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default HotelEntry;
